import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';
import { registerSW } from 'virtual:pwa-register';

registerSW({ immediate: true });

const container = document.getElementById('root');

if (!container) {
  throw new Error('Hiányzik a #root elem az index.html fájlból.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
);
